import React from "react";

/**
 * VehicleDetailPowerIcon
 *
 * Icon for vehicle power detail. Used in VehicleDetailsList.
 */
const VehicleDetailPowerIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11M21 11C21 5.47715 16.5228 1 11 1M21 11H18.5M1 11C1 5.47715 5.47715 1 11 1M1 11H3.5M11 1V3.5M18.0784 4L12.4999 9.5M18.0784 18.0784L17.8745 17.8745C17.1827 17.1827 16.8368 16.8368 16.4331 16.5894C16.0753 16.3701 15.6851 16.2085 15.2769 16.1105C14.8166 16 14.3274 16 13.349 16L8.65096 16C7.6726 16 7.18342 16 6.72307 16.1106C6.31493 16.2086 5.92475 16.3702 5.56686 16.5895C5.1632 16.8369 4.8173 17.1828 4.12549 17.8746L3.92163 18.0784M3.92163 4L5.65808 5.73645M13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9C12.1046 9 13 9.89543 13 11Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default VehicleDetailPowerIcon;
